import { normalizeText, convertNotionalToBRL } from './convertNotionalToBRL.js'

export function isNegotiated(row) {
  const status = normalizeText(row.status)
  return status === 'NOTH.DONE' || status === 'DEAL'
}

// Sum of BRL notional for negotiated rows only (DEAL + NOTH.DONE).
// effectiveSpotByRow must come from createEffectiveSpotMap(allRows).
export function calculateNegotiatedVolumeBRL(rows, effectiveSpotByRow) {
  return rows.reduce((total, row) => {
    if (!isNegotiated(row)) return total

    const amount = convertNotionalToBRL(row, effectiveSpotByRow.get(row))

    if (amount == null) return total

    return total + amount
  }, 0)
}
